/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * 
 * @export
 * @interface CreateOtherSystemSourceInsightInput
 */
export interface CreateOtherSystemSourceInsightInput {
    /**
     * 
     * @type {string}
     * @memberof CreateOtherSystemSourceInsightInput
     */
    since?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherSystemSourceInsightInput
     */
    until?: string;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof CreateOtherSystemSourceInsightInput
     */
    spend?: MoneyOutput;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherSystemSourceInsightInput
     */
    note?: string | null;
}

/**
 * Check if a given object implements the CreateOtherSystemSourceInsightInput interface.
 */
export function instanceOfCreateOtherSystemSourceInsightInput(value: object): value is CreateOtherSystemSourceInsightInput {
    return true;
}

export function CreateOtherSystemSourceInsightInputFromJSON(json: any): CreateOtherSystemSourceInsightInput {
    return CreateOtherSystemSourceInsightInputFromJSONTyped(json, false);
}

export function CreateOtherSystemSourceInsightInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOtherSystemSourceInsightInput {
    if (json == null) {
        return json;
    }
    return {
        
        'since': json['since'] == null ? undefined : json['since'],
        'until': json['until'] == null ? undefined : json['until'],
        'spend': json['spend'] == null ? undefined : MoneyOutputFromJSON(json['spend']),
        'note': json['note'] === undefined ? undefined : json['note'] === null ? null : json['note'],
    };
}

export function CreateOtherSystemSourceInsightInputToJSON(json: any): CreateOtherSystemSourceInsightInput {
    return CreateOtherSystemSourceInsightInputToJSONTyped(json, false);
}

export function CreateOtherSystemSourceInsightInputToJSONTyped(value?: CreateOtherSystemSourceInsightInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'since': value['since'],
        'until': value['until'],
        'spend': MoneyOutputToJSON(value['spend']),
        'note': value['note'],
    };
}

